import { Injectable } from '@angular/core'
import { ApiService } from './api.service'
import { sendAppLinkSuccessMessage } from '../helpers/app-link'
import { NGXLogger } from 'ngx-logger'
// import { NotifierService } from 'angular-notifier'

@Injectable({
  providedIn: 'root'
})
export class SendAppLinkService {

  constructor(
    private api: ApiService,
    private logger: NGXLogger,
    // private notifier: NotifierService,
  ) { }


  sendAppLinkObjWrapper(body, that?: any) {
    this.api.sendAppLinkObj(body).toPromise().then(
      (data) => {
        this.logger.info(data)
        // this.notifier.notify('success', sendAppLinkSuccessMessage)
        if (that) {
          that.toggleLoader(false)
          that.cdr.detectChanges()
        }
      }, (error: any) => {
        console.error(error)
        const errs = { status: error.status, error: error.error }
        // this.notifier.notify('error', JSON.stringify(errs))
        if (that) {
          that.toggleLoader(false)
          that.cdr.detectChanges()
        }
      })
  }

  sendAppLinkWrapper(loanAcctId: string, phone: string, emailAddress: string, cobo?: boolean, that?: any) {
    const body = {
      loanAcctId: loanAcctId || '',
      phone: phone ||  '',
      emailAddress: emailAddress || '',
      cobo: cobo || undefined,
    }
    this.sendAppLinkObjWrapper(body, that)
  }

  sendJoinIcwWrapper(emailAddress: string, that?: any) {
    this.api.sendJoinICWPrepared(emailAddress).toPromise().then(
      (data) => {
        this.logger.info(data)
        // this.notifier.notify('success', sendAppLinkSuccessMessage)
        if (that) {
          that.toggleLoader(false)
          that.cdr.detectChanges()
        }
      }, (error: any) => {
        console.error(error)
        const errs = { status: error.status, error: error.error }
        // this.notifier.notify('error', JSON.stringify(errs))
        if (that) {
          that.toggleLoader(false)
          that.cdr.detectChanges()
        }
      })
  }

}
